import rules from "@/utils/formRules/rules";
export default {
  data () {
    return {
      formRules: { // 表单验证规则

        siteType: [{
          required: true,
          message: '请选择球场类型',
          trigger: 'change'
        }],
        grassType: [{
          required: true,
          message: '请选择草皮类型',
          trigger: 'change'
        }],
        siteQualityType: [{
          required: true,
          message: '请选择球场性质',
          trigger: 'change'
        }],
        countyCode: [{ required: true, message: '请选择区', trigger: 'change' }],
        cityCode: [{ required: true, message: '请选择市', trigger: 'change' }],
        siteName: [{
          required: true,
          message: '请输入球场名称',
          trigger: 'blur'
        }],
        siteAddress: [{
          required: true,
          message: '请输入球场地址',
          trigger: 'blur'
        }],
        propertyUnit: [{
          required: true,
          message: '请输入产权单位',
          trigger: 'blur'
        }],
        operatingUnit: [{
          required: true,
          message: '请输入运营单位',
          trigger: 'blur'
        }],
        propertyType: [{
          required: true,
          message: '请选择产权类型',
          trigger: 'change'
        }],
        cooperationStartDate: [{
          required: true,
          message: '请选择合同开始时间',
          trigger: 'change'
        }],
        cooperationEndDate: [{
          required: true,
          message: '请选择合同截止时间',
          trigger: 'change'
        }],

        completeTime: [{
          required: true,
          message: '请选择合同截止时间',
          trigger: 'change'
        }],

        youthUuid: [{ required: true, message: '请选择精英机构', trigger: 'change' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
//        usePermissions: [{
//          required: true,
//          message: '请输入使用权限期限',
//          trigger: 'blur'
//        }],
        usePermissions: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value && value !==0) {
              callback(new Error('请输入使用权限期限'))
            } else {
              if (rules.isNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入大于等于0的数字'))
              }
            }
          },
          trigger: 'blur'
        }],
        useTimePeriod: [{
          required: true,
          message: '请输入使用时段',
          trigger: 'blur'
        }],
        lamplight: [{
          required: true,
          message: '请输入灯光情况',
          trigger: 'blur'
        }],
        grandstand: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value && value !==0) {
              callback(new Error('请输入看台数量'))
            } else {
              if (rules.isNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入大于等于0的数字'))
              }
            }
          },
          trigger: 'blur'
        }],
      },
    }
  }
}
